let vetstoriaScriptsRequested = false;

const loadVetstoriaScripts = async (): Promise<void> => {
  const siteInitializationScript = document.querySelector<HTMLScriptElement>(
    'script[src*="/dist/site-initialization.js"]'
  );
  const vetstoriaScriptPaths = [
    siteInitializationScript?.dataset.vetstoriaBookingTrackerUrl,
    siteInitializationScript?.dataset.vetstoriaBookingButtonUrl
  ].filter((path): path is string => path !== undefined);

  for (const path of vetstoriaScriptPaths) {
    if (document.querySelector(`script[src^="${path}"]`)) {
      continue;
    }

    await new Promise<void>((resolve, reject) => {
      const script = document.createElement("script");
      script.src = path;
      script.addEventListener("load", () => resolve());
      script.addEventListener("error", () => reject());
      document.head.appendChild(script);
    });
  }

  document.dispatchEvent(new CustomEvent("vetstoria-booking-script-loaded"));
};

htmx.onLoad(rootElement => {
  if (!rootElement.querySelector("[data-vetstoria-booking-button]")) {
    return;
  }

  // htmx swaps can contain booking buttons repeatedly, so only load once
  // (including while a load is in flight), but allow a retry if loading fails
  if (vetstoriaScriptsRequested) {
    return;
  }

  vetstoriaScriptsRequested = true;
  loadVetstoriaScripts().catch(() => {
    vetstoriaScriptsRequested = false;
  });
});
